module.exports = __webpack_public_path__ + "img/logotipo_black.e551f29c.png";